/**
 * Created by tofael on 3/23/17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import Menu from 'material-ui/svg-icons/navigation/menu';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {white} from 'material-ui/styles/colors';

class Header extends React.Component {

  render() {
    const {styles, signOut} = this.props;

    const style = {
      appBar: {
        top: 0,
        overflow: 'hidden',
        maxHeight: 57,
        backgroundColor: '#1C2B36'
      },
      menuButton: {
        marginLeft: 10
      },
      iconsRightContainer: {
        marginLeft: 20
      }
    };

    return (
        <div>
          <AppBar
              style={{...styles, ...style.appBar}}
              title={' '}
              iconElementLeft={
                <IconButton style={style.menuButton} onClick={this.props.handleChangeRequestNavDrawer} >
                  <Menu color={white} />
                </IconButton>
              }
              iconElementRight={
                <div style={style.iconsRightContainer}>
                  <IconMenu color={white}
                            iconButtonElement={
                              <IconButton><MoreVertIcon color={white}/></IconButton>
                            }
                            targetOrigin={{horizontal: 'right', vertical: 'top'}}
                            anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                  >
                    <MenuItem onClick={signOut} primaryText="Sign out"/>
                  </IconMenu>
                </div>
              }
          />

        </div>
    );
  }
}

Header.propTypes = {
  styles: PropTypes.object,
  handleChangeRequestNavDrawer: PropTypes.func
};

export default Header;



// WEBPACK FOOTER //
// ./src/screens/layout/header.js